module.exports = __webpack_public_path__ + "static/CVS-BeVapeFree_VFT_Educator_Guide-4fc291050ef6875be9541f9a32c0f42a.pdf";